import { ALPHA_MAX_STYLE_PICKS, type AlphaStylePick } from "@nlc/shared-types";

// Plan 0 follows the brief as is; each pick shapes one more plan.
export const ALPHA_PLAN_COUNT = ALPHA_MAX_STYLE_PICKS + 1;

export function isSamePick(a: AlphaStylePick, b: AlphaStylePick): boolean {
  if (a.kind === "inspiration") {
    return b.kind === "inspiration" && a.inspirationId === b.inspirationId;
  }

  return b.kind === "upload" && a.attachmentId === b.attachmentId;
}

export function isPicked(
  picks: AlphaStylePick[],
  pick: AlphaStylePick,
): boolean {
  return picks.some((candidate) => isSamePick(candidate, pick));
}

export function isPickLimitReached(picks: AlphaStylePick[]): boolean {
  return picks.length >= ALPHA_MAX_STYLE_PICKS;
}

export function togglePick(
  picks: AlphaStylePick[],
  pick: AlphaStylePick,
): AlphaStylePick[] {
  if (isPicked(picks, pick)) {
    return picks.filter((candidate) => !isSamePick(candidate, pick));
  }

  return isPickLimitReached(picks) ? picks : [...picks, pick];
}

export function dropMissingUploads(
  picks: AlphaStylePick[],
  uploadIds: number[],
): AlphaStylePick[] {
  return picks.filter(
    (pick) =>
      pick.kind === "inspiration" || uploadIds.includes(pick.attachmentId),
  );
}
